const listSpaces = ({ year, token }, { observer, spacesRepo }) => {
  spacesRepo.listSpaces(
    { year, token },
    {
      success: (response) => {
        if (response.error) {
          observer.failure()
          return
        }

        observer.success(response.data)
      },
      failure: () => {
        observer.failure()
      }
    }
  )
}

export default listSpaces
